import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { ObservableUtil, ObservableBlockPanel, ObservableBlockPanelDoc } from '../util/observable-util';

@Component({
  selector: 'base-barprogress',
  styleUrls: ['../../assets/sass/custom/blockpanel.scss'],
  template: `
    <p-blockUI [blocked]="blockedPanel">
    <div class="dados">
      <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" autofocus></circle>
      </svg>
    </div>
  </p-blockUI>
    <ng-progress style="pointer-events:none" [positionUsing]="'marginLeft'" [minimum]="0.15" [maximum]="1" [speed]="300" [showSpinner]="true"
        [direction]="'leftToRightIncreased'" [color]="'#b78c1c'" [trickleSpeed]="250" [thick]="true" [ease]="'linear'">
    </ng-progress>
    `})
export class BaseBarProgressComponent implements OnInit {
  constructor(private observableUtil: ObservableBlockPanel, private observableUtilPanelDoc: ObservableBlockPanelDoc) { }
  blockedPanel: boolean;

  ngOnInit() {
    this.observableUtilPanelDoc.getBlockedPanel().subscribe(panelDoc => {
      this.observableUtil.getBlockedPanel().subscribe(data => {
        this.blockedPanel = panelDoc.text;
        if (panelDoc == false) {
          this.blockedPanel = data.text;
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/base/base-barprogress.component.ts